(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["movitamins-custom-header-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('movitamins-header')) {
  customElements.define('movitamins-header', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.menus = [...this.querySelectorAll('.mv2-desktop-menu')];
      this.dialogs = [...this.querySelectorAll('.mv2-dialog')];
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-mv2-open]');
        if (opener) {
          this.returnTarget = opener;
          this.closeMenus();
          this.dialogs.forEach(dialog => { if (dialog.open) dialog.close(); });
          const dialog = document.getElementById(opener.dataset.mv2Open);
          dialog.showModal();
          dialog.querySelector('input[type="search"]')?.focus();
        }
        const closer = event.target.closest('[data-mv2-close]');
        if (closer) closer.closest('dialog').close();
        const summary = event.target.closest('.mv2-desktop-menu > summary');
        if (summary) this.menus.forEach(menu => {
          if (menu !== summary.parentElement) menu.open = false;
        });
      }, options);
      document.addEventListener('click', event => {
        if (!event.target.closest('.mv2-desktop-menu')) this.closeMenus();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const openDialog = this.dialogs.find(dialog => dialog.open);
          if (openDialog) { event.preventDefault(); openDialog.close(); return; }
          const openMenu = this.menus.find(menu => menu.open);
          if (openMenu) { openMenu.open = false; openMenu.querySelector('summary').focus(); }
        }
      }, options);
      this.dialogs.forEach(dialog => {
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => this.returnTarget?.focus(), options);
      });
      this.media = matchMedia('(max-width: 950px)');
      this.media.addEventListener('change', () => {
        this.closeMenus();
        this.querySelector('.mv2-menu-dialog')?.close();
      }, options);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(this)) this.dialogs.forEach(dialog => dialog.close());
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        const section = this.closest('.section-header');
        const styles = getComputedStyle(section);
        document.documentElement.style.setProperty('--header-height', section.offsetHeight + 'px');
        // The part that stays on screen while scrolling: the sticky header minus the utility bar
        // that scrolls away. Sticky page elements use it to stay clear of the header.
        const utilityHeight = parseFloat(styles.getPropertyValue('--mv2-utility-height')) || 0;
        const stickyOffset = styles.position === 'sticky' ? section.offsetHeight - utilityHeight : 0;
        document.documentElement.style.setProperty('--mv-sticky-header-offset', stickyOffset + 'px');
      });
      this.resizeObserver.observe(this);
      const cartLink = this.querySelector('#cart-icon-bubble');
      this.addEventListener('click', event => {
        if (event.defaultPrevented || !event.target.closest('#cart-icon-bubble')) return;
        const drawer = document.querySelector('cart-drawer');
        if (drawer) { event.preventDefault(); drawer.open(cartLink); }
      }, options);
    }
    closeMenus() { this.menus.forEach(menu => menu.open = false); }
    disconnectedCallback() {
      this.dialogs?.forEach(dialog => dialog.close());
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
